<template>
  <main
    class="flex h-screen w-full flex-col items-center justify-center bg-gray-900"
  >
    <h1 class="text-9xl font-extrabold tracking-widest text-white">
      {{ error.statusCode }}
    </h1>
    <div
      class="absolute -rotate-6 transform rounded bg-green-500 px-2 py-1 text-sm text-white"
    >
      {{ error.message }}
    </div>
    <button
      role="link"
      class="group relative mt-5 inline-block text-sm font-medium focus:outline-none focus:ring active:text-orange-500"
      @click="navigateBack"
    >
      <span
        class="absolute inset-0 translate-x-0.5 translate-y-0.5 transition-transform group-hover:translate-x-0 group-hover:translate-y-0"
      />
      <span
        class="relative block border border-white px-8 py-3 text-white shadow"
      >
        Go Back
      </span>
    </button>
  </main>
</template>

<script setup lang="ts">
import type { NuxtError } from '#app'

defineProps({
  error: { type: Object as () => NuxtError, required: true },
})

const navigateBack = () => {
  // clearError();
  useNuxtApp().$router.back()
}
</script>
